/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API SSO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ChangeConsentDto } from '../models';
// @ts-ignore
import type { ChangeUserData } from '../models';
// @ts-ignore
import type { FilterUserDto } from '../models';
// @ts-ignore
import type { UserMetaDto } from '../models';
// @ts-ignore
import type { UserPageableResponseDto } from '../models';
// @ts-ignore
import type { UserSelectDto } from '../models';
/**
 * USERApi - axios parameter creator
 * @export
 */
export const USERApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ChangeConsentDto} changeConsentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerChangeConsent: async (changeConsentDto: ChangeConsentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changeConsentDto' is not null or undefined
            assertParamExists('userControllerChangeConsent', 'changeConsentDto', changeConsentDto)
            const localVarPath = `/user/changeConsent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "apiKey", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeConsentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ChangeUserData} changeUserData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerChangeMe: async (changeUserData: ChangeUserData, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changeUserData' is not null or undefined
            assertParamExists('userControllerChangeMe', 'changeUserData', changeUserData)
            const localVarPath = `/user/changeMe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "apiKey", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeUserData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {ChangeUserData} changeUserData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerChangeUserById: async (userId: string, changeUserData: ChangeUserData, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userControllerChangeUserById', 'userId', userId)
            // verify required parameter 'changeUserData' is not null or undefined
            assertParamExists('userControllerChangeUserById', 'changeUserData', changeUserData)
            const localVarPath = `/user/changeUserById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "apiKey", configuration)

            // authentication accessToken required

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeUserData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FilterUserDto} filterUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetAllUsers: async (filterUserDto: FilterUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filterUserDto' is not null or undefined
            assertParamExists('userControllerGetAllUsers', 'filterUserDto', filterUserDto)
            const localVarPath = `/user/getAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "apiKey", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filterUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetMe: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/getMe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "apiKey", configuration)

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetUserById: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userControllerGetUserById', 'userId', userId)
            const localVarPath = `/user/getById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "apiKey", configuration)

            // authentication accessToken required

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение метаданных пользователя по userId
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetUserMetaByUserId: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userControllerGetUserMetaByUserId', 'userId', userId)
            const localVarPath = `/user/getMetaByUserId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "apiKey", configuration)

            // authentication accessToken required

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * USERApi - functional programming interface
 * @export
 */
export const USERApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = USERApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ChangeConsentDto} changeConsentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerChangeConsent(changeConsentDto: ChangeConsentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerChangeConsent(changeConsentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['USERApi.userControllerChangeConsent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ChangeUserData} changeUserData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerChangeMe(changeUserData: ChangeUserData, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerChangeMe(changeUserData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['USERApi.userControllerChangeMe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {ChangeUserData} changeUserData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerChangeUserById(userId: string, changeUserData: ChangeUserData, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerChangeUserById(userId, changeUserData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['USERApi.userControllerChangeUserById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {FilterUserDto} filterUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetAllUsers(filterUserDto: FilterUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserPageableResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetAllUsers(filterUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['USERApi.userControllerGetAllUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetMe(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSelectDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetMe(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['USERApi.userControllerGetMe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetUserById(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSelectDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetUserById(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['USERApi.userControllerGetUserById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение метаданных пользователя по userId
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetUserMetaByUserId(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserMetaDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetUserMetaByUserId(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['USERApi.userControllerGetUserMetaByUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * USERApi - factory interface
 * @export
 */
export const USERApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = USERApiFp(configuration)
    return {
        /**
         * 
         * @param {ChangeConsentDto} changeConsentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerChangeConsent(changeConsentDto: ChangeConsentDto, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.userControllerChangeConsent(changeConsentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChangeUserData} changeUserData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerChangeMe(changeUserData: ChangeUserData, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.userControllerChangeMe(changeUserData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {ChangeUserData} changeUserData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerChangeUserById(userId: string, changeUserData: ChangeUserData, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.userControllerChangeUserById(userId, changeUserData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilterUserDto} filterUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetAllUsers(filterUserDto: FilterUserDto, options?: RawAxiosRequestConfig): AxiosPromise<UserPageableResponseDto> {
            return localVarFp.userControllerGetAllUsers(filterUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetMe(options?: RawAxiosRequestConfig): AxiosPromise<UserSelectDto> {
            return localVarFp.userControllerGetMe(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetUserById(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserSelectDto> {
            return localVarFp.userControllerGetUserById(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение метаданных пользователя по userId
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetUserMetaByUserId(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserMetaDto>> {
            return localVarFp.userControllerGetUserMetaByUserId(userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * USERApi - object-oriented interface
 * @export
 * @class USERApi
 * @extends {BaseAPI}
 */
export class USERApi extends BaseAPI {
    /**
     * 
     * @param {ChangeConsentDto} changeConsentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof USERApi
     */
    public userControllerChangeConsent(changeConsentDto: ChangeConsentDto, options?: RawAxiosRequestConfig) {
        return USERApiFp(this.configuration).userControllerChangeConsent(changeConsentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChangeUserData} changeUserData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof USERApi
     */
    public userControllerChangeMe(changeUserData: ChangeUserData, options?: RawAxiosRequestConfig) {
        return USERApiFp(this.configuration).userControllerChangeMe(changeUserData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {ChangeUserData} changeUserData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof USERApi
     */
    public userControllerChangeUserById(userId: string, changeUserData: ChangeUserData, options?: RawAxiosRequestConfig) {
        return USERApiFp(this.configuration).userControllerChangeUserById(userId, changeUserData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilterUserDto} filterUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof USERApi
     */
    public userControllerGetAllUsers(filterUserDto: FilterUserDto, options?: RawAxiosRequestConfig) {
        return USERApiFp(this.configuration).userControllerGetAllUsers(filterUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof USERApi
     */
    public userControllerGetMe(options?: RawAxiosRequestConfig) {
        return USERApiFp(this.configuration).userControllerGetMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof USERApi
     */
    public userControllerGetUserById(userId: string, options?: RawAxiosRequestConfig) {
        return USERApiFp(this.configuration).userControllerGetUserById(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение метаданных пользователя по userId
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof USERApi
     */
    public userControllerGetUserMetaByUserId(userId: string, options?: RawAxiosRequestConfig) {
        return USERApiFp(this.configuration).userControllerGetUserMetaByUserId(userId, options).then((request) => request(this.axios, this.basePath));
    }
}

